import React from 'react'

import { action, makeObservable, observable } from 'mobx'
import { inject, observer } from 'mobx-react'

import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

interface IProps {
  shouldRenderDot?: boolean
  projectDateStore?: ProjectDateStore
}

const SECONDS_IN_MIN = 60
const SECONDS_IN_DAY = 86400

@inject('projectDateStore')
@observer
export default class CalendarTimeline extends React.Component<IProps> {
  private intervalId: number

  @observable private topOffset: string = null
  @observable private currentTime: number = 0

  public constructor(props: IProps) {
    super(props)
    this.setCurrentTime()
    makeObservable(this)
  }

  public componentDidMount() {
    this.intervalId = window.setInterval(() => {
      this.setCurrentTime()
    }, SECONDS_IN_MIN * 1000)
  }

  public componentWillUnmount() {
    window.clearInterval(this.intervalId)
  }

  public render() {
    const { shouldRenderDot } = this.props
    return (
      <div
        style={{ top: this.topOffset }}
        className="tw:absolute tw:z-[3] tw:w-full tw:pointer-events-none"
      >
        {shouldRenderDot && (
          <div className="tw:absolute tw:top-[-4px] tw:left-[-5px] tw:z-[2] tw:h-[10px] tw:w-[10px] tw:rounded-[10px] tw:bg-destructive" />
        )}
        <div className="tw:absolute tw:z-[2] tw:h-[2px] tw:w-full tw:bg-destructive" />
      </div>
    )
  }

  @action
  private setTop = () => {
    this.topOffset = `${((this.currentTime * 100) / SECONDS_IN_DAY).toFixed(
      2,
    )}%`
  }

  @action
  private setCurrentTime = () => {
    this.currentTime = this.props.projectDateStore.getDaySeconds(new Date())
    this.setTop()
  }
}
